import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _Promise from 'babel-runtime/core-js/promise';
import sget from '@xunlei/sget';

function isElectron() {
  if (typeof process === 'undefined') {
    return false;
  } else {
    return sget(process, 'versions', 'electron');
  }
}

function isDef(v) {
  return v !== undefined && v !== null;
}

function isUndef(v) {
  return v === undefined || v === null;
}

function promisifySync(val) {
  return new _Promise(function (resolve, reject) {
    val ? resolve() : reject();
  });
}

function warn(component, message) {
  console.warn('[Warn][' + component + '], ' + message);
}

function throttle(fn, delay, context) {
  var last = 0;
  return function () {
    var curr = +new Date();
    if (curr - last > delay) {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      fn.apply(context || this, args);
      last = curr;
    }
  };
}

function debounce(fn, delay, context) {
  var timer = null;
  return function () {
    clearTimeout(timer);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    timer = setTimeout(fn.bind.apply(fn, [context || this].concat(args)), delay);
  };
}

function swap(arr, a, b) {
var _ref = [arr[b], arr[a]];
  arr[a] = _ref[0];
  arr[b] = _ref[1];
}
// 只是为了提供给 Message 组件的
var LimitationMessageQueue = function () {
  function LimitationMessageQueue(options) {
    _classCallCheck(this, LimitationMessageQueue);

    this.unique = options.unique || false;
    this.maxLength = options.maxLength || -1;
    this.queue = [];
    this.uniqueById = options.uniqueById || false;
  }

  _createClass(LimitationMessageQueue, [{
    key: 'push',
    value: function push(item) {
      try {
        this.queue = this.queue.filter(function (message) {
          return message.timer !== undefined && message.timer !== null;
        });
        if (this.uniqueById) {
          this.queue.forEach(function (item) {
            item.$destroy();
          });
          this.queue = [];
        } else if (this.unique) {
          var destroyList = this.queue.filter(function (message) {
            return item.type === message.type && item.message === message.message;
          });
          this.queue = this.queue.filter(function (message) {
            return !(item.type === message.type && item.message === message.message);
          });
          destroyList.forEach(function (item) {
            item.$destroy();
          });
        }
        if (this.maxLength <= -1 || this.queue.length < this.maxLength) {
          this.queue.push(item);
          return true;
        } else {
          while (this.queue.length >= this.maxLength) {
            var cur = this.queue.shift();
            cur.$destroy();
          }
          this.queue.push(item);
          return true;
        }
      } catch (err) {
        console.error(err);
        return false;
      }
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.queue = this.queue.filter(function (message) {
        return message.timer !== undefined && message.timer !== null;
      });
      return this.queue.length;
    }
  }]);

  return LimitationMessageQueue;
}();

var once = function once(fn) {
  var called = false;
  return function () {
    if (called) return;
    called = true;

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return fn.apply(this, args);
  };
};

export { isElectron, isDef, isUndef, promisifySync, warn, throttle, debounce, swap, LimitationMessageQueue, once };
